import App from 'app/app.js';

App.service('SessionTimeoutService', [
  '$location',
  '$injector',
  'MessageStore',
  'AppVersionUpdateService',
  function SessionTimeoutService($location, $injector, MessageStore, AppVersionUpdateService) {
    var pendingSessionTimeout = false;

    this.isPendingSessionTimeout = function () {
      return pendingSessionTimeout;
    };

    this.setPendingSessionTimeout = function (value) {
      pendingSessionTimeout = value;
    };

    this.refresh = function () {
      if (this.isSessionTimeoutRedirect()) {
        MessageStore.clear();
        MessageStore.createSystem(this.getMessage());

        $injector.get('OrderFormService').goToSignIn();

        this.setPendingSessionTimeout(false);

        AppVersionUpdateService.showAlertIfAppVersionUpdateRequired();
      }
    };

    this.isSessionTimeoutRedirect = function () {
      var message = this.getMessage();

      return message && message.includes('SESSION_TIMEOUT');
    };

    this.getMessage = function () {
      return $location.search().message;
    };
  }
]);
